<template>
	<el-container>
		<el-aside width="200px">

			<SideMenu></SideMenu>

		</el-aside>
		<el-container>
			<el-header>
				<strong>UX体验管理平台</strong>

				<div class="header-avatar">

					<el-avatar style="margin-left: 80px;" size="medium" :src="userInfo.avatar"></el-avatar>

					<el-dropdown>
						<span class="el-dropdown-link">
						{{userInfo.username}}<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>
								<router-link :to="{name: 'UserCenter'}">个人中心</router-link>
							</el-dropdown-item>
							<el-dropdown-item @click.native="logout">退出</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>

			</el-header>
			<el-main>
				<Tabs></Tabs>
				<div style="margin: 0 15px;">
					<router-view/>
				</div>
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
	import SideMenu from "./inc/SideMenu";
	import Tabs from "./inc/Tabs";

	export default {
		name: "Home",
		components: {
			SideMenu, Tabs
		},
		data() {
			return {
				userInfo: {
					id: "",
					username: "",
					avatar: ""
				}
			}
		},
		created() {
			this.getUserInfo()
		},
		methods: {
			getUserInfo() {
				this.$axios.get("/sys/userInfo").then(res => {
					// 防止空指针异常：检查响应数据是否存在
					if (res && res.data && res.data.data) {
						this.userInfo = res.data.data
					}
				}).catch(error => {
					// 错误处理：如果获取用户信息失败，使用默认值
					console.error('获取用户信息失败:', error)
					this.userInfo = {
						id: "",
						username: "未知用户",
						avatar: ""
					}
				})
			},
			logout() {
				// 无论后端是否响应，都执行退出操作
				this.$axios.post("/logout").then(res => {
					this.doLogout()
				}).catch(error => {
					// 即使后端服务不可用，也执行退出操作
					console.error('退出登录请求失败:', error)
					this.doLogout()
				})
			},
			doLogout() {
				// 统一的退出逻辑
				localStorage.clear()
				sessionStorage.clear()
				this.$store.commit("resetState")
				this.$router.push("/login")
			}
		}
	}
</script>

<style scoped>
	.el-container {
		padding: 0;
		margin: 0;
		height: 100%;
	}

	.header-avatar {
		float: right;
		width: 210px;
		display: flex;
		justify-content: space-around;
		align-items: center;
	}

	.el-dropdown-link {
		cursor: pointer;
	}

	.el-header {
		background-color: #17B3A3;
		color: #333;
		text-align: center;
		line-height: 60px;
	}

	.el-aside {
		background-color: #D3DCE6;
		color: #333;
		line-height: 200px;
	}

	.el-main {
		color: #333;
		padding: 0;
		background-color: #ffffff;
	}

	a {
		text-decoration: none;
	}
</style>
